import * as React from 'react';
import { PwaInstallModal } from 'components/PwaInstallModal';
import { usePwaDeferredInstallPrompt } from 'utils/usePwaDeferredInstallPrompt';
import { isPhoneMobileDevice } from 'utils/pwa-nav';
import { canOfferPwaInstallPrompt, dismissPwaInstallPrompt } from 'utils/pwa';

const PROMPT_DELAY_MS = 2000;

/**
 * Mobile-browser install popup: Android uses `beforeinstallprompt`; iOS shows
 * Add-to-Home-Screen steps (Safari does not allow programmatic install).
 */
export const PwaInstallBanner: React.FC = () => {
  // Capture `beforeinstallprompt` as early as possible for settings + popup flows.
  usePwaDeferredInstallPrompt();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    if (!isPhoneMobileDevice() || !canOfferPwaInstallPrompt()) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      if (canOfferPwaInstallPrompt()) {
        setOpen(true);
      }
    }, PROMPT_DELAY_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleDismiss = React.useCallback(() => {
    dismissPwaInstallPrompt();
    setOpen(false);
  }, []);

  return (
    <PwaInstallModal
      open={open}
      onClose={handleClose}
      onDismiss={handleDismiss}
    />
  );
};

export default PwaInstallBanner;
